import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { defer, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PwaActivityService } from '../services/pwa-activity.service';

@Injectable()
export class PwaActivityInterceptor implements HttpInterceptor {
  constructor(private activity: PwaActivityService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return defer(() => {
      const finish = this.activity.beginOperation();
      return defer(() => next.handle(request)).pipe(finalize(finish));
    });
  }
}
